import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { css } from "styled-components";

const footerStyles = {
    container: {
        css: css`
            background-color: #131b42;
            max-width: none !important;
            margin: auto;
        `,
    },
};

const Footer: React.FunctionComponent<PageProps> = ({ id }: PageProps) => (
    <Page as="footer" isFooter={true} {...footerStyles.container}>
        <Zone contentId={id} zoneName="Content" />
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
